<nb-card>
  <nb-card-header>صف گزارشات</nb-card-header>
  <nb-card-body>
    <p-table
      [tableStyle]="{'min-width': '80rem'}"
      [value]="reportQueueList"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [rowTrackBy]="trackBy"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [loading]="getListLoading"
      [paginator]="true"
      [rows]="50"
      [totalRecords]="reportQueueList.length"
    >
      <ng-template pTemplate="header">
        <tr>
          <td>شناسه‌گزارش</td>
          <td>نام گزارش</td>
          <td>ورودی‌ها</td>
          <td>وضعیت</td>
          <td>تاریخ ثبت درخواست</td>
          <td>تاریخ شروع گزارش‌گیری</td>
          <td>تاریخ پایان گزارش‌گیری</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-result>
        <tr>
          <td>{{ result.id }}</td>
          <td>{{ result.name }}</td>
          <td>
            <button (click)="showReportPayload(result)" nbButton status="primary" size="small">ورودی‌ها</button>
          </td>
          <td>
            <div class="d-flex flex-column gap-2">
              <span *ngIf="result.status === 'PENDING' || result.status === 'PROCESSING'" class="text-warning" disabled
                    nbButton>
              <i title="در حال آماده‌سازی" class="fas fa-sync fa-spin text-warning"></i>
            </span>
              <a *ngIf="result.status === 'SUCCESSFUL'" download (click)="setSelectedReportDownload(result)"
                 [href]="result.link" appDownloadWithCredential
                 (downloadProgress)="downloadProgress = $event" target="_blank" rel="noreferrer noopener"
                 status="primary"
                 size="small"
                 nbButton>
                دانلود
              </a>
              <span *ngIf="result.status === 'FAILED'" class="text-danger">خطا</span>
              <nb-progress-bar *ngIf="downloadProgress !== undefined && selectedDownloadReport === result.id"
                               [value]="downloadProgress" status="primary"
                               [displayValue]="true"></nb-progress-bar>
            </div>
          </td>
          <td>{{ result.createdAt | dateFormat : 'jDD jMMMM jYYYY HH:mm:ss' }}</td>
          <td>{{ result.startedAt ? (result.startedAt | dateFormat : 'jDD jMMMM jYYYY HH:mm:ss') : '-' }}</td>
          <td>{{ result.finishedAt ? (result.finishedAt | dateFormat : 'jDD jMMMM jYYYY HH:mm:ss') : '-' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">هیج گزارشی در دسترس نیست.</td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
<ng-template #JSONOutputTemplate>
  <nb-card>
    <nb-card-body>
      <div style="direction: ltr;text-align: left" id="report-filter-container"></div>
    </nb-card-body>
  </nb-card>
</ng-template>
